import * as Modals from 'fw/globals/Modals';

export const handleDeletePointOfContact = (index, onDeletePointOfContact) => {
	Modals.confirm(
		"You are about to Delete this Point of Contact. <br /><br />" +
		"If you wish to retain this Point of Contact, please select 'No', and you will be returned to the previous screen. <br /><br />" +
		"If you wish to remove this Point of Contact, please select 'Yes'.",
		function () {
			onDeletePointOfContact(index);
		}
	);
}

export const handleChangePointOfContact = (index, value, controlName, pointOfContactList, onUpdatePointOfContactList) => {
	var item = pointOfContactList[index];
	item[controlName] = value;

	onUpdatePointOfContactList(index, item);
};

export const setTip = (property, tooltips) => {
	const tooltip = tooltips.find(t => t.code === property)
	return tooltip !== undefined ? tooltip.tip : null
}


// WEBPACK FOOTER //
// ./src/areas/shared/helpers/PointOfContactListHelpers.js